import { render, staticRenderFns } from "./ConfigProdutoEdit.vue?vue&type=template&id=631bf368"
import script from "./ConfigProdutoEdit.vue?vue&type=script&lang=js"
export * from "./ConfigProdutoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports